import { render } from "./ChipGroup.vue?vue&type=template&id=d4368cec&scoped=true"
import script from "./ChipGroup.vue?vue&type=script&lang=js"
export * from "./ChipGroup.vue?vue&type=script&lang=js"

import "./ChipGroup.vue?vue&type=style&index=0&id=d4368cec&lang=scss"
import "./ChipGroup.vue?vue&type=style&index=1&id=d4368cec&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/vueApps/ronchipiero.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4368cec"]])

export default __exports__